import { Injectable } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { RideOpsUiService } from "source/app/configuration/services/rideops-ui.service";
import { ClosingTimeReminderComponent } from "./closing-time-reminder.component";

@Injectable({ providedIn: "root" })
export class ClosingTimeReminderModalService {
	constructor(
		private modalController: ModalController,
		private rideOpsUi: RideOpsUiService,
	) {}

	async show(): Promise<void> {
		const modal = await this.modalController.create({
			id: ClosingTimeReminderComponent.modalId,
			component: ClosingTimeReminderComponent,
			showBackdrop: true,
			backdropDismiss: false,
			cssClass: this.rideOpsUi.isV2Active()
				? "closing-time-reminder-modal-v2"
				: "closing-time-reminder-modal auto-height",
		});

		await modal.present();
	}
}
